import DashboardLayout from "./layout/DashboardLayout";
import MemPool from "./Mempool";

const MempoolComponent = () => {
  return (
    <DashboardLayout>
      <MemPool />
    </DashboardLayout>
  );
};

export default MempoolComponent;
